module.exports = __webpack_public_path__ + "static/media/affiliate-challenge-bg.2886491d.jpg";